import { render, staticRenderFns } from "./customer-detail.vue?vue&type=template&id=9287805e"
import script from "./customer-detail.vue?vue&type=script&lang=js"
export * from "./customer-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports